
<div class="" style="margin-left: 75px">
    <d-site
        v-model  = "dialog"
        :site-id = "siteId"
        @saved   = "onSaved"
    />

    <c-app-bar
        title          = "ANLAGEN"
        :categories    = "['site']"
        :enable-search = "false"
    >
        <template slot="search">
            <m-site-search
                class   = "ml-2"
                @search = "onSearch"
            />
            <v-spacer />
        </template>
    </c-app-bar>

    <c-customer-index
        :minimize      = "false"
        :enable-search = "true"
        :filter-height = "225"
        @changed       = "onCustomer"
        style          = "padding-right: 75px;"
    >
        <template v-slot:detail="{  }">
            <m-site-table
                :customer = "customerId"
                :data     = "data"
                @selected = "onSite"
                ref       = "table"
            />
        </template>
    </c-customer-index>
</div>
